import React, { Component, useMemo } from 'react';
import Subtitle from 'components/commercetools-ui/atoms/subtitle';
import Typography from 'components/commercetools-ui/atoms/typography';
import Wrapper from 'components/HOC/wrapper';
import CustomerSupportSlide from './slide';
import Markdown from '../markdown';
import { CustomerSupportProps } from './types';

const CustomerSupport: React.FC<CustomerSupportProps> = ({ title, subtitle, slides, columns, backgroundColor }) => {
  const slidesElement = useMemo(
    () => slides?.map((slide) => <CustomerSupportSlide key={slide.title} {...slide} />),
    [slides],
  );
  const colElement = useMemo(
    () =>
      columns?.map((col, index) => (
        <Markdown
          key={`col${index}`}
          unsafeMarkdown={col.unsafeMarkdown}
          markdown={col.markdown}
          className="prose w-full max-w-full overflow-hidden no-underline"
        />
      )),
    [columns],
  );
  return (
    <Wrapper className="py-24 lg:pb-36 lg:pt-0" background={backgroundColor}>
      <div className="flex flex-col items-start justify-between rounded-2xl border border-gray-500 px-24 pb-32 pt-12 md:px-48 md:pb-48 md:pt-24">
        {title && (
          <Typography className="mb-12 pt-12 text-20 text-primary-black md:text-28 lg:text-32" as="h3">
            {title}
          </Typography>
        )}
        {subtitle && <Subtitle className="mb-24" subtitle={subtitle} />}
        {slidesElement && <div className="flex w-full flex-col gap-24 md:flex-row">{slidesElement}</div>}
        {colElement && <div className="flex w-full flex-col gap-24 md:flex-row">{colElement}</div>}
      </div>
    </Wrapper>
  );
};

export default CustomerSupport;
